import React, { Component } from "react"
import { connect } from "react-redux"
import _ from "lodash"

import { Put } from 'utils/axios'
import { processSite } from 'utils/host'
import { handleErrorMsg, getSelectedLanguageContent } from "utils"
import { requestError, requestSuccess } from 'utils/requestHandler'
import { addLoadingContent, removeLoadingContent } from 'reducers/LoadingOverlay'

const HOC = WrapperComponent => {
  class WithHOC extends Component {
    state = {
      token: ""
    }
    load = param => {
      if( param ){
        this.props.addLoadingContent()
      } else {
        this.props.removeLoadingContent()
      }
    }

    componentDidMount = () => {
      if( window.location.hash.includes( 'token=' ) ){
        this.setState({ token: window.location.hash.split('token=')[1] })
      } else {
        this.setState({ token: "" })
      }
    }

    onSubmitForm = formData => {
      if( _.isEmpty( this.state.token ) ){
        this.verifyEmail(formData)
      } else {
        this.changePassword( { password: formData.password }, this.state.token )
      }
    }

    verifyEmail = data => Put(
      `/client_users/${ processSite( window.location.host ) }/forgot_password_email`,
      data,
      this.verifyEmailSuccess,
      this.verifyEmailError,
      this.load,
      true
    )
    verifyEmailSuccess = () => {
      this.props.history.push( "/login" )
      requestSuccess( getSelectedLanguageContent("{{VERIFICATION_EMAIL_HAS_BEEN_SENT}}") )
    }
    verifyEmailError = error => requestError( handleErrorMsg( error ) )

    changePassword = ( data, token ) => Put(
      `/client_users_reset_forgot_password`,
      data,
      this.changePasswordSuccess,
      this.changePasswordError,
      this.load,
      false,
      token
    )
    changePasswordSuccess = () => {
      this.props.history.push( "/login" )
      requestSuccess( getSelectedLanguageContent("{{PASSWORD_HAS_BEEN_RESET}}") )
    }
    changePasswordError = error => requestError( handleErrorMsg( error ) )

    render = () => {
      return (
        <WrapperComponent 
          {...this.props} 
          token={ this.state.token }
          onSubmitForm={ this.onSubmitForm } />
      )
    }
  }

  const mapStateToProps = state => ({ 
    data: state,
    colors: state.ClientReducer.clientInfo.styles?.colors,
    selectedLanguage: state.ProfileReducer.profile.preferred_language,
    clientInfo: state.ClientReducer.clientInfo
  })

  return connect( mapStateToProps, { addLoadingContent, removeLoadingContent } )( WithHOC )
}

export default HOC
